<template>
  <div id="experience-layout">
    <ExperienceSidebar></ExperienceSidebar>
    <div class="main-wrapper">
      <main>
        <Suspense>
          <router-view v-slot="{ Component, route }">
            <transition mode="out-in" name="fade">
              <div class="page-wrapper" :key="route.path">
                <component :is="Component" :id="route.name" />
              </div>
            </transition>
          </router-view>
        </Suspense>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, watch, inject } from "vue";

import ExperienceSidebar from "@/components/sidebarV2/ExperienceSidebar.vue";

const crisp: any = inject("crisp");
const { candidate } = useCandidateStore();
const currentVersion = ref(null)

async function checkVersion() {
  const res = await fetch('/version.json');
  const data = await res.json();

  if (currentVersion.value && currentVersion.value !== data.version) {
    window.location.reload();
  }

  axiosInstance.defaults.headers.common['x-app-version'] = data.version; // Add the version to the headers
  currentVersion.value = data.version;
}

watch(candidate, () => {
  if (candidate.id) {
    crisp.user.setEmail(candidate.personal_information.email);
    crisp.user.setNickname(`${candidate.personal_information.first_name} ${candidate.personal_information.last_name}`);
    crisp.session.setData({
      user_id: candidate.id,
    });
  }
});

onMounted(async () => {
  crisp.session.setSegments(["Candidat"]);
  checkVersion();
  setInterval(checkVersion, 5000); // check every 5s
});

</script>

<style lang="scss" scoped>

#experience-layout {
  display: flex;
  overflow: hidden;
  max-height: 100vh;

  .main-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    overflow: hidden;
  }
  
  main {
    flex: 1;
    overflow: auto;
    padding: 0;
    margin: 0;
    width: 100%;
    //max-height: 100svh;
    padding: 20px;
    padding-top: 40px;
    margin-bottom: 20px;
    display: flex;
    position: relative;
    
    .page-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
      flex: 1;
    }
  }
}
</style>
